import {connect} from 'react-redux'
import withRouter from "../../../components/RouterComponentWrapper";
import TurnierDetail from "../../../components/views/liga/TurnierDetail";

const mapStateToProps = function (state, ownProps) {
    const urlParams = new URLSearchParams(ownProps.router.location.search);
    const turnierId = urlParams.get('turnierid');
    return {turnierid: turnierId, userId: state.user.id, leagueoperators: state.leagueoperator.leagueoperators};
};

const mapDispatchToProps = dispatch => ({
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TurnierDetail))